import React from 'react';
import { Link, scroller } from 'react-scroll';

const SECTIONS = [
  { id: 'page-title', label: '', className: 'd-none' },
  { id: 'prices', label: 'Preise' },
  { id: 'about-us', label: 'Über Uns' },
  { id: 'philosophy', label: 'Philosophie', linkClass: 'products' },
  { id: 'book', label: 'Termin buchen' },
  { id: 'contact-us', label: 'Kontakt' },
];

const SCROLL_OPTIONS = { smooth: true, duration: 0, offset: -70 };

const Nav = (props) => {
  if (props.for === 'desktop' && window.innerWidth < 768) {
    return null;
  }

  // On mobile the drawer locks body scroll (body-scroll-lock), so react-scroll's
  // own click handler can't move the page and the spy never fires. Close the
  // drawer first, then scroll once the lock is released.
  const handleClick = (id) => {
    if (props.for !== 'mobile') return;
    props.handleClose && props.handleClose();
    window.setTimeout(() => {
      scroller.scrollTo(id, SCROLL_OPTIONS);
      props.handleSetSection(id);
    }, 50);
  };

  return (
    <ul className="nav navbar-nav">
      {SECTIONS.map((s) => (
        <li key={s.id} className={`nav-item ${s.className || ''}`.trim()}>
          <Link href={`#${s.id}`}
            to={s.id}
            spy={ true }
            smooth={ SCROLL_OPTIONS.smooth }
            duration={ SCROLL_OPTIONS.duration }
            offset={ SCROLL_OPTIONS.offset }
            activeClass="active"
            onSetActive={() => props.handleSetSection(s.id)}
            onClick={() => handleClick(s.id)}
            className={`${s.linkClass || s.id} nav-link scroll-to-id`}>
            {s.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Nav;
